const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, payload) {
    try {
      var url = `/api/syllabus-teacher?classroomId=${payload.classroomId ? payload.classroomId : ''}&search=${
        payload.search ? payload.search : ''
      }&status=${payload.status !== null && payload.status !== '' && typeof payload.status != 'undefined' ? payload.status : ''}`;

      const {
        data: { data }
      } = await window.axios.get(url);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getDataDetail({ commit }, payload) {
    try {
      let url;
      if (!payload.isStudent) {
        url = `/api/syllabus-teacher/classroom/${payload.classroomId}/course/${payload.courseId}`;
      } else {
        url = `/api/syllabus-student/classroom/${payload.classroomId}/course/${payload.courseId}`;
      }
      const {
        data: { data }
      } = await window.axios.get(url);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  downloadSyllabus({ commit }, payload) {
    let url;
    let mode;
    if (payload.potrait === true) {
      mode = 'potrait';
    } else {
      mode = 'landscape';
    }
    if (!payload.isStudent) {
      url = `/api/syllabus-teacher/${payload.id}/download?orientation=${mode}`;
    } else {
      url = `/api/syllabus-student/${payload.id}/download?orientation=${mode}`;
    }
    return window.axios.get(`${url}`, { responseType: 'arraybuffer' });
  },
  // eslint-disable-next-line no-unused-vars
  save({ commit }, payload) {
    if (payload.file === null) {
      delete payload.file;
      delete payload.fileName;
    }
    if (payload.text === false) {
      delete payload.potrait;
    }
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    return window.axios.post('/api/syllabus-teacher', formData);
  },
  // eslint-disable-next-line no-unused-vars
  update({ commit }, payload) {
    if (payload.file === undefined || payload.file === null) {
      delete payload.file;
      delete payload.fileName;
    }

    payload.syllabusId = payload.id;
    delete payload.id;
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    return window.axios.put(`/api/syllabus-teacher/${payload.syllabusId}`, formData);
  },
  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, payload) {
    try {
      var url = `/api/syllabus-teacher/${payload}`;
      const {
        data: { data }
      } = await window.axios.get(url);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/syllabus-teacher/${payload}`);
  }
};

export default { namespaced, state, getters, mutations, actions };
